<template lang="html">
  <form class="forgot-password" @submit.prevent="handleFormForgotPassword">
    <div class="form-content">
      <label class="form-row">
        <div class="label-text">Trouble logging in?</div>
        <input
          v-model="email"
          v-focus
          name="email"
          type="email"
          autocomplete="email"
          placeholder="Email address"
          required
        />
      </label>

      <BaseLoadingButton
        class="form-row"
        button-text="Send Login Link"
        :disabled="!email"
        :is-loading="isLoading"
      />

      <p class="form-row">
        <router-link :to="{ name: 'login' }">Back to login</router-link>
      </p>
    </div>
  </form>
</template>

<script>
import authenticationMixin from '@/mixins/authentication';

export default {
  name: 'ForgotPassword',
  mixins: [authenticationMixin],
};
</script>

<style scoped lang="scss"></style>
